import React, {useContext, useState} from 'react';
import TextField from "@mui/material/TextField";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {enums} from "../utils/enums";
import {createUserWithEmailAndPassword} from "firebase/auth";
import {auth, db} from "../utils/firebaseApp";
import {doc, setDoc} from "firebase/firestore";
import {toast} from "react-toastify";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import {PersonAddAlt} from "@mui/icons-material";
import {AppContext} from "../utils/AppContext";

const AddUserModule = ({setOpenAddModal}) => {
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const {state: {currentUser, stands, users}, dispatch} = useContext(AppContext);
    const [stand, setStandUid] = useState(null)

    console.log('stands')
    console.log(stands)

    function createUser() {
        createUserWithEmailAndPassword(auth, email, password)
            .then(async (userCredential) => {
                const user = userCredential.user;
                console.log(user)
                let userData = {
                    uid: user.uid,
                    event: currentUser.event,
                    joined: Date.now(),
                    role: role,
                    email: email,
                }

                if (role === enums.BARTENDER) userData.stand = stand
                console.log(userData)
                await setDoc(doc(db, "users", user.uid), userData);
                dispatch({users: [...users, userData]})
                toast.success('User created')
                setOpenAddModal(false)
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                toast.error(errorMessage)
                // ..
            });
    }

    return (
        <>
            <Stack spacing={2}>
                <TextField
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    margin="normal"
                    required
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                />
                <TextField
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    margin="normal"
                    required
                    name="password"
                    label="Password"
                    id="password"
                />

                <FormControl>
                    <InputLabel id="demo-simple-select-label">Role</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={role}
                        label="Age"
                        onChange={e => setRole(e.target.value)}
                    >
                        <MenuItem value={enums.BARTENDER}>BARTENDER</MenuItem>
                        <MenuItem value={enums.BANKER}>BANKER</MenuItem>
                        <MenuItem value={enums.VALIDATOR}>VALIDATOR</MenuItem>
                    </Select>
                </FormControl>

                {role === enums.BARTENDER ? <FormControl>
                        <InputLabel id="demo-simple-select-label">Stand</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={stand}
                            label="stand"
                            onChange={e => {
                                setStandUid(e.target.value)
                            }}
                        >
                            {stands.map(stand => <MenuItem value={stand.uid}>{stand.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    : null}


                <Button
                    disabled={email.length < 5 || password.length < 5 || role.length < 1 || (role === enums.BARTENDER && !stand)}
                    variant={'contained'} onClick={() => createUser()}>
                    <PersonAddAlt sx={{marginRight: 1}}/>
                    Dodaj Korisnika</Button>
            </Stack>
        </>
    );
};

export default AddUserModule;
